import { observer } from 'mobx-react-lite'
import React, { type FC } from 'react'
import { Call } from '@twilio/voice-sdk'
import { type ITabItem, Tabs } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import styles from './styles.module.scss'

type ICallInsightCardsTabsProps = {
  callBack?: () => void
}

export const CallInsightCardsTabs: FC<ICallInsightCardsTabsProps> = observer(({ callBack }) => {
  const { callPopUpInsightCardsStore, status } = useCallPopUpDefaultContext()

  const { setTabKey, activeTab, showCallTypesModal } = callPopUpInsightCardsStore
  const handleSelectTab = (tab: ITabItem) => {
    setTabKey(tab.key)
  }
  const disabledNote = status !== Call.State.Open && !showCallTypesModal
  const tabs: ITabItem[] = [
    {
      name: 'Details',
      key: 'details',
    },
    {
      name: 'Note',
      key: 'note',
      disabled: disabledNote,
      tooltipProps: disabledNote
        ? {
            zIndex: ZIndex.OVERLAY_TOP_1,
            label: 'Notes aren’t available until the call is picked up',
            placement: 'top',
          }
        : undefined,
    },
  ]

  return (
    <div className={styles.tabs}>
      <Tabs
        variant={'simpleWithoutBorder'}
        tabs={tabs}
        activeTabKey={activeTab}
        handleSelectTab={handleSelectTab}
        handleClickTab={() => callBack?.()}
        withStopPropagation
      />
    </div>
  )
})
